export const type = {
  pageTitle: "text-sm font-bold text-slate-900",
  sectionTitle: "text-sm font-bold text-slate-800",
  sectionSubtitle: "text-xs leading-4 text-slate-500",
  body: "text-xs leading-4 text-slate-700",
  help: "text-[11px] leading-4 text-slate-500",
  bannerTitle: "text-[13px] font-bold leading-4 text-white",
  bannerBody: "text-[12px] leading-[1.35] text-blue-50",
  table: "text-[11px]",
  button: "text-sm font-medium",
};
